import { createContext, useContext, useEffect, useRef } from "react";
import MxMapObservedUpdateCityAndSector from "../components/MxMapObservedUpdateCityAndSector";

const MxMapLayoutContext = createContext<any>(null);

interface I_MxMapLayout {
  children: React.ReactNode;
  fieldsNames: {
    lat?: string;
    lng?: string;
    address?: string;
    city?: string;
    country?: string;
    sector?: string;
    direction?: string;
    manual?: boolean;
    search?: string;
  };
}
const MxMapLayout = ({ children, fieldsNames }: I_MxMapLayout) => {
  const map_layout = useRef<any>({
    canLoad: false
  });
  useEffect(() => {
    const timeout = setTimeout(() => {
      map_layout.current.canLoad = true;
      console.log("map_layout.current.canLoad", map_layout.current.canLoad);
    }, 1000);
    return () => {
      clearTimeout(timeout);
      if (map_layout.current) {
        map_layout.current.canLoad = false;
      }
    };
  }, []);
  return (
    <MxMapLayoutContext.Provider value={{ fieldsNames, map_layout }}>
      <MxMapObservedUpdateCityAndSector fieldsNames={fieldsNames} />
      {children}
    </MxMapLayoutContext.Provider>
  );
};

export default MxMapLayout;

export const useMxMapLayoutContext = () => useContext(MxMapLayoutContext);
